(function () {
  if (!window.SpotmateTracking || typeof window.SpotmateTracking.push !== 'function') return;

  var successMarkers = document.querySelectorAll('[data-spotmate-success-event]');
  successMarkers.forEach(function (marker) {
    var eventName = marker.getAttribute('data-spotmate-success-event');
    var formLocation = marker.getAttribute('data-spotmate-location') || 'unknown';
    var sectionId = marker.getAttribute('data-spotmate-section') || 'unknown';
    if (!eventName) return;

    window.SpotmateTracking.push(
      eventName,
      {
        form_type: 'email',
        form_location: formLocation,
        section_id: sectionId
      },
      {
        dedupeKey: [eventName, formLocation, sectionId].join(':'),
        dedupeWindowMs: 10000
      }
    );
  });
})();
